var _ellipse, _path, _rect, _rect2, _ellipse2, _path2, _rect3, _rect4, _path3, _path4, _path5, _circle, _polygon, _circle2, _polygon2, _circle3, _path6, _path7, _path8, _path9, _circle4, _path10, _path11, _ellipse3, _path12, _path13, _polygon3, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 910.90802,
    height: 704.99598,
    viewBox: "0 0 910.90802 704.99598",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 697.31696,
    cy: 542.77039,
    rx: 48.50275,
    ry: 98.96521,
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M837.38391,802.26252c19.42584-116.55145.19556-232.68182-.00091-233.84027l-3.77869.64008c.19556,1.15289,19.31543,116.67309-.00092,232.57135Z",
    transform: "translate(-144.54599 -97.50201)",
    fill: "#cacaca"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 818.26998,
    y: 607.54206,
    width: 3.83319,
    height: 49.73956,
    transform: "translate(-268.85332 959.85926) rotate(-61.8584)",
    fill: "#cacaca"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 841.60854,
    y: 642.25327,
    width: 49.74127,
    height: 3.83319,
    transform: "translate(-345.98446 387.63054) rotate(-28.15796)",
    fill: "#cacaca"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 813.85468,
    cy: 386.14381,
    rx: 94.86566,
    ry: 193.56433,
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M947.83405,800.179c37.944-227.6604.38275-454.49169-.00092-456.75628l-3.77869.64007c.38275,2.259,37.83362,228.48017-.00091,455.48737Z",
    transform: "translate(-144.54599 -97.50201)",
    fill: "#cacaca"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 914.08784,
    y: 419.62722,
    width: 3.83319,
    height: 97.28711,
    transform: "translate(-73.4911 957.62642) rotate(-61.8584)",
    fill: "#cacaca"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 957.90319,
    y: 489.35201,
    width: 97.28717,
    height: 3.83319,
    transform: "translate(-257.25314 435.62254) rotate(-28.15742)",
    fill: "#cacaca"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M738.0755,800.78724H233.47931a7.00818,7.00818,0,0,1-7-7V474.94154a7.00785,7.00785,0,0,1,7-7H738.0755a7.00817,7.00817,0,0,1,7,7v318.8457A7.00848,7.00848,0,0,1,738.0755,800.78724Z",
    transform: "translate(-144.54599 -97.50201)",
    fill: "#e4e4e4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M279.88361,506.57923a3.00328,3.00328,0,0,0-3,3V759.15052a3.00328,3.00328,0,0,0,3,3H691.6712a3.00328,3.00328,0,0,0,3-3V509.57923a3.00328,3.00328,0,0,0-3-3Z",
    transform: "translate(-144.54599 -97.50201)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M695.67095,570.85921V555.04439H637.4373V505.57918H621.62236v49.46521H517.94707V505.57918H502.13262v49.46521H342.22685V505.57918H326.41191v49.46521H271.11748v15.81482h55.29443v61.50214H271.11748v15.81482h55.29443v65.89514H271.11748v15.81482h140.519V763.15h15.81494V729.88613h74.68116V763.15h15.81445V729.88613H695.67095V714.07131H517.94707V648.17617H695.67095V632.36135H637.4373V570.85921Zm-193.53833,0v19.32928H342.22685V570.85921Zm-159.90577,35.1441H502.13262v26.358H342.22685Zm0,108.068V648.17617h69.40967v65.89514Zm159.90577,0H427.45146V648.17617h74.68116Zm119.48974-81.71H517.94707V570.85921H621.62236Z",
    transform: "translate(-144.54599 -97.50201)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 365.49384,
    cy: 544.76679,
    r: 20.20782,
    fill: "#f4323c"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "910.513 704.996 0 704.996 0 702.814 910.908 702.814 910.513 704.996",
    fill: "#cacaca"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.91605,
    cy: 300.06687,
    r: 124.6554,
    fill: "#f4323c"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "369.135 502.707 329.753 435.433 290.371 368.159 368.323 367.69 446.275 367.221 407.705 434.964 369.135 502.707",
    fill: "#f4323c"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 368.91666,
    cy: 299.28272,
    r: 44.72449,
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M509.57867,98.14253s-26.67361-7.51371-34.563,28.92773-2.87842,31.85-2.87842,31.85l59.546-6.95017S549.58911,109.22521,509.57867,98.14253Z",
    transform: "translate(-144.54599 -97.50201)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M470.7874,258.01223s-40.24153,1.86275-33.27269,17.65871q.73892,1.67489,1.37584,3.13846a282.52157,282.52157,0,0,0,17.16391,33.22306l24.73294,40.97977,9-5-25.32671-65.837,22.76474-1.85834Z",
    transform: "translate(-144.54599 -97.50201)",
    fill: "#ffb6b6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M576.89062,274.7418l13.00843,28.33978s9.75628,9.75632,20.44177,48.78159,13.00842,37.63153,13.00842,37.63153l-10.56184,3.51753-43.33025-78.78056-21.371-26.946,6.50421-14.40219Z",
    transform: "translate(-144.54599 -97.50201)",
    fill: "#ffb6b6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M561.09473,242.22071l18.69267,34.79152s42.38015,83.27659,38,83c-4.92373-.31093-18.75364,5.42831-23,11-2.04957,2.68926-32-63-42.51988-77.68693L529.50275,275.671s-64.63613,10.8788-64.71535,7.34123c-.0388-1.73284,21.39973,39.8423,17,38-5.012-2.09867-16.80244,8.11375-22,6-2.14452-.87214-17.29757-37.61145-23.43159-52.6662a8.14809,8.14809,0,0,1,3.76974-10.31057c4.60991-2.39749,68.66185-17.02323,68.66185-17.02323l-1.12019-5.72066,4.6459-9.29174Z",
    transform: "translate(-144.54599 -97.50201)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 504.87902,
    cy: 136.75794,
    r: 18.1189,
    transform: "translate(144.46959 515.71005) rotate(-80.78268)",
    fill: "#ffb6b6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M562.7874,245.01223c1.00049,3.00146-5.47911,4.72554-14.51067,3.03908-7.81427-1.4588-16.36737-3.19171-23.11322-4.59476-7.2243-1.50525-12.3858-2.62954-12.3858-2.62954s-1.85834,11.61465-7.898,10.22088c-5.20334-1.19864-20.753-55.51343-24.95758-70.52423a5.2218,5.2218,0,0,1,2.309-5.86774l21.357-13.041s14.71811-5.05471,20.08408-5.19871,14.65772-1.53778,14.65772-1.53778,10.68548.92918,12.54388,8.82713,9.61285,54.72575,9.75629,65.9713C560.7874,242.01223,559.7874,236.01223,562.7874,245.01223Z",
    transform: "translate(-144.54599 -97.50201)",
    fill: "#cacaca"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M511.65363,113.48475s-7.51371,19.9113-25.92228,28.17636l-3.00546-17.65719Z",
    transform: "translate(-144.54599 -97.50201)",
    fill: "#2f2e41"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 377.98804,
    cy: 32.28878,
    rx: 2.55524,
    ry: 4.87816,
    fill: "#ffb6b6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M497.27629,357.65805l-35.91687,16.5124-.20887-.45428a15.38729,15.38729,0,0,1,7.5521-20.407l.00089-.00041,21.93684-10.08514Z",
    transform: "translate(-144.54599 -97.50201)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M607.43293,390.64713l22.03165-9.8763.00089-.0004a15.3873,15.3873,0,0,1,20.33383,7.74694l.20451.45627-36.07222,16.17022Z",
    transform: "translate(-144.54599 -97.50201)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "403.241 104.51 399.035 150.771 406.512 151.124 403.241 104.51",
    opacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M518.46828,288.434a9.13591,9.13591,0,0,0-1.99925-13.8654L500.3102,192.94265l-18.55613,7.09923,21.71849,78.00329A9.1854,9.1854,0,0,0,518.46828,288.434Z",
    transform: "translate(-144.54599 -97.50201)",
    fill: "#ffb6b6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M504.39837,206.69964,484.023,210.2884a4.09641,4.09641,0,0,1-4.80539-3.92235l-.56235-20.61872a11.37649,11.37649,0,0,1,22.41945-3.88108l6.49978,19.50525a4.0964,4.0964,0,0,1-3.17607,5.32814Z",
    transform: "translate(-144.54599 -97.50201)",
    fill: "#cacaca"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M534.09046,286.99792a9.13584,9.13584,0,0,0,2.55241-13.7743l10.86868-82.49709-19.8527.77413-4.441,80.84851a9.1854,9.1854,0,0,0,10.87258,14.64875Z",
    transform: "translate(-144.54599 -97.50201)",
    fill: "#ffb6b6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M546.97251,205.068l-20.45025-3.13434a4.09642,4.09642,0,0,1-3.29389-5.25613l6.07895-19.71025a11.37649,11.37649,0,0,1,22.48008,3.5129l-.098,20.55948a4.09641,4.09641,0,0,1-4.71689,4.02834Z",
    transform: "translate(-144.54599 -97.50201)",
    fill: "#cacaca"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocation);
export default __webpack_public_path__ + "static/media/currentLocation.5c90c374d4ed0d60726aceac775ad23d.svg";
export { ForwardRef as ReactComponent };